import {
  DynamicZoneComponentDTO,
  StrapiDynamicZoneComponentDTO,
} from "@lib/strapi/dtos/core/dynamicZoneComponent.dto";
import { parseStrapiContent } from "@lib/strapi/content";
import {
  StrapiLinkDTO,
  LinkDTO,
} from "@lib/strapi/dtos/components/shared/link.dto";
import {
  StrapiMenuItemDTO,
  MenuItemDTO,
} from "@lib/strapi/dtos/components/menu/menuItem.dto";
import { StrapiMediaDTO } from "@lib/strapi/dtos/core/media.dto";
import { ImageProps } from "@lib/image";

export interface StrapiMenuHeaderDTO extends StrapiDynamicZoneComponentDTO {
  link: StrapiLinkDTO;
  menuItems: StrapiMenuItemDTO[];
  image: StrapiMediaDTO;
}

export class MenuHeaderDTO extends DynamicZoneComponentDTO {
  constructor() {
    super();
  }

  link: LinkDTO;
  menuItems: MenuItemDTO[];
  image: ImageProps;
}
